/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/08/31 17:29:18
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class NvRadio extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区
    /**
     * label
     * icon
     * text
     */
    @Prop({ default: () => ([]) })
    radioItems?: any[];

    @Prop({ default: '' })
    value: any;

    radioValue: any = "";

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {

    }

    //#endregion 事件定义区

    //#region 方法定义区

    @Watch("value")
    valueChange(val) {
        this.radioValue = val;
    }

    doRadioChange() {
        this.$emit('input', this.radioValue);
    }

    //#endregion 方法定义区
}